/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { Claim } from '../../auth/core/_models'
import { ClaimModel } from './ClaimModel'


type Props = {
  className: string
  title: string
  description: string
  avatar: string
  link: string | undefined
  Claim: Claim[]
}

const ClaimLinkWidget: React.FC<Props> = ({ className, title, description, avatar, link, Claim }) => {
  const [modalShow, setModalShow] = useState(false);
  if (Claim.length !== 0) {
    return (
      <>
        <a className={` `} onClick={() => setModalShow(true)}>
          <div className='border bg-light-primary border-primary border-dashed rounded 
                                                             py-3 px-4 me-6 mb-3 border-hover-success 
                                                            bg-hover-primary text-hover-white'>
            <div className='d-flex align-items-center'>
              <div className='fs-6 fw-bolder'> {title} </div>
            </div>


          </div>
        </a>
        <ClaimModel show={modalShow} handleClose={() => setModalShow(false)} Claim={Claim} />
      </>

    )
  }

  else {
    return (<div className='border bg-light-primary border-primary border-dashed rounded 
     py-3 px-4 me-6 mb-3'>
      <div className='d-flex align-items-center'>
        <div className='fs-6 fw-bolder'> {title} </div>
      </div>
    </div>)
  }


}

export { ClaimLinkWidget }
